import type { Result as SetAmountResult } from './useSetAmount';
import { useSetAmount } from './useSetAmount';

type Result = {
	setAmount: SetAmountResult;
};

export function useActions(): Result {
	return {
		setAmount: useSetAmount(),
	};
}
